// import React, { Component , useEffect,useState } from 'react';

import $, {  } from 'jquery';
import { getCookie, isArray, isDevMachine, isString } from './general';
import { handleActionsLocally } from '../app/storage/phpSimulation';
import axios from 'axios';
import { hideDialog, showDialog } from './modal_dialog';

// function showDialog(){

// }
// function hideDialog(){
    
// }
var modelObjectAdapters = {
}

var store = undefined;
var ajaxUri = undefined;

export function setupCommand(settings){
  ajaxUri = settings.ajaxUri;
  modelObjectAdapters = settings.modelObjectAdapters?settings.modelObjectAdapters:{};
  store = settings.store;
}

export function ensureCmdArgs(args) {
    
  if (Array.isArray(args)){
    return {
      actions : args
    }
  } else if (args.action) {
      args.actions = [args.action];
      delete args.action;
      return args;
  } else if (!args.actions) {
    return {
      actions : [args]
    }
  } else {
    return args;
  }
  
}

function updateModel ( state , action ) {

    var onPostModelUpdate= action.onPostModelUpdate;

  var newModel = state.model;

  if (action.clearModel){

      if (action.clearModel=='*'){
          newModel = {};
      } else {
  
          var clearStacks = action.clearModel;
          if (!isArray(action.clearModel)){
            clearStacks = [action.clearModel];
          }
          clearStacks.map(objectType=>{
              if (isString(objectType)){
                  delete newModel[objectType];
              } else {
                  objectType(newModel);
              }
          });
      }
  }

  for (var updateKey in action.modelUpdates){

      var update =  action.modelUpdates[updateKey];
  
      adaptModeObjects(updateKey,update);
  
      if (isArray(update)){
          newModel[updateKey] = update;
      } else {
          if (!newModel[updateKey] ){
            newModel[updateKey]={}
          }
          delete update.dummy ; // might have been inserted to ensure an empty object is not sent as an array
          $.extend( newModel[updateKey] ,update);
      }

    }
//   console.log (newModel);
  state.model = newModel;

    if (onPostModelUpdate){
        onPostModelUpdate(state);
    }

}

function adaptModeObjects(key,objects){

    const adapter = modelObjectAdapters[key];
    if (adapter){
        $.map(objects,obj=>{
            return adapter(obj)
        });
    }

}
export function sendCommand(args,count=0){

 
  args = ensureCmdArgs(args);
  const { 
    actions, clearModel , 
    modal , systemFailureIsFatal,failSilently, 
    onResponse,onCompleted,onSucceeded,onPostModelUpdate,onError
  } = args;

  // console.log ("Send Cmd...");
  // console.log (args);

  const jason_commands = JSON.stringify({
    loggedInUserId : args.loggedInUserId,
    sessionToken : getCookie('HostDiag'), // DEVELOPMENT sessionToken should go up with cookies not like this
    actions : actions
  });

  if (modal) {
    // turn model on
    showDialog({
      title : 'Loading...',
      message:"Please Wait"
    });
    // store.dispatch({ type : 'setMessage', message : 'Please wait' }); 
  }

  function handleResponse (response ) {
    const report = response?.data?.report;

    // console.log ("Cmd Response...");
    // console.log (response);
    
    if (report && report?.ok){

      onFinished('succeeded',{
        modelUpdates : response.data.modelUpdates,
        actionPayloads : response.data.actionPayloads
      });
    
    } else {


      if (onError && onError[report?.error]){
          onError[report.error]();
      } else {  
        showDialog({
            title : "Error communicating with the server.",
            message : "Unknown error",
        })     
        // if (count<3 ){
        //     setTimeout(() => sendCommand(args,count+1),10);
        // } else {
        //   onFinished('systemFailure');
        // }
      }

    }
  }

  function onFinished( type , successContext={}){
    
    const succeeded = type=='succeeded';
    const systemFailure = type=='systemFailure';

    if (modal) {
      hideDialog();
    }

    if (!succeeded && !failSilently) {
      showDialog( {message:'There was a problem please try later',ok:true});
    } 

    if (onResponse){
      onResponse(type,successContext);
    }
    if (succeeded ){

      const {modelUpdates,actionPayloads} = successContext;

      if ( modelUpdates ) {

        var action = {
          type : 'modelUpdate',
          modelUpdates : modelUpdates,
          clearModel : clearModel?clearModel:false,
          onPostModelUpdate : onPostModelUpdate
        }
        // if (clearModel && clearModel.clearModel){
        //   action = $.extend (action,clearModel);
        // }
        store.dispatch(updateModel,action);
      }

      // individual action handlers
      for (var i=0;i<actions.length;i++){
        if (actions[i].onSucceeded){
          actions[i].onSucceeded(actionPayloads[i]);
        }
      }

      if (onSucceeded){
        onSucceeded();
      }
    }

    if (onCompleted){
      onCompleted (
        (systemFailureIsFatal && systemFailure ) ? 'fatalSystemFailure' : type
      );
    }

  }

  // send commands as if axios was installed
  // loggedInUserId
  // actions

  if (ajaxUri == 'local'){
    handleActionsLocally(actions,handleResponse);
  } else {
    axios ( {
      method: 'POST',
      url: ajaxUri,//'',  //MAMP
      data: jason_commands,
      //credentials: 'include',
      // headers : {
      //   startan : jason_commands
      // }
    } ).then (
      response => {
        if (isDevMachine) {
          setTimeout(()=>{handleResponse(response);},10);
        } else {
          handleResponse(response);
        }
      }
      
    ).catch(function (error) {

      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
        showDialog({
          title:"Server Error",
          message: error?.response?.data + " : " + error?.response?.status  + " : " +  error?.response?.headers,
        });
      } else if (error?.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        // console.log(error.request);

        showDialog({
          title:"Server Error : No response",
          message:error?.request
        })

      } else {
        // Something happened in setting up the request that triggered an Error
        // console.log('Error', error.message);
        showDialog({
          title:"Server Error : Invalid request",
          message:error?.message
        })
      }
      console.log(error?.config);
    });
  }




  

}
  